module.exports = __webpack_public_path__ + "img/doorLogo23.d6bdf49a.png";